import { type ReactNode } from 'react';
import styled from 'styled-components';
import { AlertKeys } from '../UI/Alert/Alert.types';

export function Modal({
    children,
    alert,
}: {
    children: ReactNode;
    alert: AlertKeys;
}) {
    console.log({ alert });
    if (alert === AlertKeys.none) return null;
    return <StyledAlertOverlay>{children}</StyledAlertOverlay>;
}

const StyledAlertOverlay = styled.div`
    position: fixed;
    inset: 0;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;
